module.exports = __webpack_public_path__ + "media/stylesheets/images/userway_logo_images/voltaren-ce73fb32fbf867f77656a211fb51f036.png";